import { componentSizes } from '@vuesax-plus/constants'
import type { ComponentSize } from '@vuesax-plus/constants'

export const isValidComponentSize = (val: string): val is ComponentSize | '' =>
  ['', ...componentSizes].includes(val)
